module.exports = __webpack_public_path__ + "img/cohesion.0bc198dc.svg";